import dynamic from 'next/dynamic'

export const DynamicMembershipPurchaseModal = dynamic(
  () => import('.').then((mod) => mod.MembershipPurchaseModal),
  { ssr: false },
)
